import styled from 'styled-components';
import { mq } from '@phishtool/ui';
export const StyledSection = styled.div.withConfig({ displayName: "StyledSection", componentId: "-q0xqm7" }) `
  position: relative;
  overflow: hidden;

  &:nth-child(even) {
    background-color: ${(props) => props.theme.colors.white};
    border-top: 1px solid ${(props) => props.theme.colors.silverPearl};
    border-bottom: 1px solid ${(props) => props.theme.colors.silverPearl};
  }

  ${(props) => mq({
    padding: [`${props.theme.spacers.xxl} 0`, null, `${props.theme.spacers.massive} 0`],
})}
`;
export const StyledSectionContent = styled.div.withConfig({ displayName: "StyledSectionContent", componentId: "-bm4t1c" }) `
  position: relative;
`;
